<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable persistent :fullscreen="telaCheia" width="100vw">
      <v-card>
        <v-card-title class="headline">
          {{ title }}
          <button class="close-modal" type="button" @click="fechar">
            <i class="icon close"></i>
          </button>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div style="height: 65vh">
            <iframe
              id="printModal"
              name="printModal"
              :key="url"
              :src="url"
              style="width: 100%; height: 65vh; border: 0;"
            >
            </iframe>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions bac>
          <v-spacer></v-spacer>
          <Button
            title="Maximizar"
            classIcon="icon expand"
            buttonColor="yellow"
            @click="maximizar"
            position="right floated"
            :disabled=false
          />
          <Button
            title="Imprimir"
            classIcon="icon print"
            buttonColor="blue"
            @click="imprimir"
            position="right floated"
            :disabled=false
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Button from '@/components/Button.vue';

export default {
  name: 'ModalPrint',
  props: {
    title: String,
    dialog: Boolean,
    url: String,
  },
  components: {
    Button,
  },
  data() {
    return {
      showPrint: this.dialog,
      telaCheia: false,
    };
  },
  methods: {
    fechar() {
      this.telaCheia = false;
      this.showPrint = false;
      this.$emit('close', false);
    },
    imprimir() {
      const frame = document.getElementById('printModal');
      frame.contentWindow.postMessage('message', this.url);
    },
    maximizar() {
      this.telaCheia = true;
    },
  },
};
</script>
<style scoped lang="scss">
  .close-modal {
    position: absolute;
    right: 15px;
  }
  .v-dialog {
    overflow: hidden;

    .table-scroll {
      overflow-y: auto;
      height: 90vh;
    }
  }
</style>
